import { z } from 'zod';
import { ErrorCode } from '../../../../shared/error-codes';
import { BaseErrorSchema } from '../../../../shared/error.schema';
import { SuperAdminUserSchema } from '../../entities/superadmin-user';
import { UserStatusSchema } from '../../../../entities/user';
import { SupportedLanguageSchema } from '../../../../shared/language.schema';
/**
 * Update SuperAdmin User Request Schema
 * PATCH /api/v2/superadmin-users/:userId
 * Updates an existing superadmin user's details
 */ export const UpdateSuperAdminUserRequestSchema = z.object({
    userId: z.string(),
    firstName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    lastName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    status: UserStatusSchema.optional(),
    language: SupportedLanguageSchema.optional()
});
/**
 * Update SuperAdmin User Response Schema
 * Returned on successful user update
 * Contains the updated superadmin user object
 */ export const UpdateSuperAdminUserResponseSchema = z.object({
    user: SuperAdminUserSchema
});
/**
 * Update SuperAdmin User Error Schema
 * Returned when user update fails
 */ export const UpdateSuperAdminUserErrorSchema = BaseErrorSchema;

//# sourceMappingURL=update-superadmin-user.schema.js.map